(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amalgam-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var SUBSCRIBE_URL = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

    function klaviyo(params) {
      // Legacy list-subscribe endpoint (CORS-enabled). Step 2 re-posts the same
      // email with $first_name / $last_name to attach the name to the profile.
      // If the store's Klaviyo needs the newer client API, only this call swaps.
      return fetch(SUBSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(params)
      }).then(function (r) { return r.json(); });
    }

    function init(root) {
      if (!root || root.dataset.amNewsletterInit === '1') return;
      root.dataset.amNewsletterInit = '1';

      var step1 = root.querySelector('[data-step="1"]');
      var step2 = root.querySelector('[data-step="2"]');
      var emailForm = root.querySelector('.amalgam-newsletter__form--email');
      var nameForm = root.querySelector('.amalgam-newsletter__form--name');
      var emailInput = emailForm.querySelector('input[name="email"]');
      var message = root.querySelector('.amalgam-newsletter__message');
      var listId = root.getAttribute('data-klaviyo-list');
      var subscriberEmail = '';

      function setMessage(text, isError) {
        message.textContent = text || '';
        message.hidden = !text;
        message.classList.toggle('amalgam-newsletter__message--error', !!isError);
      }

      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailInput.value || '').trim();
        if (!EMAIL_RE.test(email)) { setMessage('Please enter a valid email address.', true); return; }
        if (!listId) { setMessage('Newsletter is not configured yet.', true); return; }

        emailForm.classList.add('is-busy');
        setMessage('');

        // Step 1 — subscribe the email; Klaviyo sends the double opt-in email.
        klaviyo({ g: listId, email: email })
          .then(function (data) {
            emailForm.classList.remove('is-busy');
            if (data && data.success) {
              subscriberEmail = email;
              step1.hidden = true;
              step2.hidden = false;
              var f = step2.querySelector('input');
              if (f) f.focus();
            } else {
              var err = data && data.errors && data.errors.length ? data.errors[0] : 'Something went wrong. Please try again.';
              setMessage(err, true);
            }
          })
          .catch(function () {
            emailForm.classList.remove('is-busy');
            setMessage('Something went wrong. Please try again.', true);
          });
      });

      if (nameForm) {
        nameForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var first = (nameForm.querySelector('input[name="first_name"]').value || '').trim();
          var last = (nameForm.querySelector('input[name="last_name"]').value || '').trim();

          nameForm.classList.add('is-busy');
          setMessage('');

          function finish() {
            nameForm.classList.remove('is-busy');
            step2.hidden = true;
            // The email opt-in already succeeded in step 1, so we thank them regardless.
            setMessage('Thank you. Please check your inbox to confirm your subscription.', false);
          }

          // Step 2 — attach the name to the profile from step 1.
          klaviyo({ g: listId, email: subscriberEmail, '$first_name': first, '$last_name': last })
            .then(finish)
            .catch(finish);
        });
      }
    }

    function scan() {
      document.querySelectorAll('.amalgam-newsletter').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
